import type { QuoterMarketConfig } from '../contract/market';

// Los valores son los que MX tiene hoy en components/quote/MX/* y mexicoChangeAmountCoverage.tsx,
// transcritos uno a uno: este RQ cambia el diseño, no las reglas del mercado.
export const MX: QuoterMarketConfig = {
  country: 'MX',
  label: 'México',
  // El rider es el mismo que INT: uno combinado, con los tipos (Criticas / Cancer) adentro.
  riders: ['terminal-illness', 'add', 'critical-cancer'],
  // MX cotiza solo en español: el selector se reemplaza por el chip del mercado.
  languages: [{ code: 'es', label: 'Español' }],
  // MX/quoteForm.tsx:399 pasa 65 al popup del asegurado; el 75 de insuredInformation.tsx:25 es el
  // default del componente, que la pantalla pisa. Ver R6 del spec.
  age: { min: 18, max: 65, maxAtExpiry: 75 },
  terms: ['10', '15', '20', '30'],
  termRule: 'ageDerived',
  frequencies: ['M', 'Q', 'S', 'A'],
  mainCoverage: { min: 100000, max: 1000000, step: 10000, easyTermMax: null },
  amountRounding: 'down',
  productRule: 'legacyThreshold',
  addRider: {
    min: 50000,
    step: 10000,
    defaultAmount: 50000,
    rangeRule: 'sharedCeiling',
  },
  // MX sirve el catálogo de montos desde la API (`lastQuote.protections`, MX/quoteForm.tsx:445),
  // no lo declara como INT. Ver R6 del spec.
  // MX no ofrece tipo de plan: cada opcion del catalogo servido ya trae su `critical_type`, y el
  // cliente elige tipo (ci/cp) + monto. El payload conserva la forma del cotizador viejo
  // (seriousIllnessProtection.tsx:84-89): { type, critical_type de la opcion, amount }.
  accidentRiders: null,
  // La principal, el ADD y la proteccion comparten el millon (BRAZ-654).
  totalCoverageLimit: 1000000,
  thousandsSeparator: ',',
  criticalIllnessCancer: {
    source: 'apiCatalog',
    amounts: [],
    types: ['ci', 'cp'],
    plans: [],
    defaultAmount: 0,
    defaultPlan: '',
  },
  incomeReplacement: null,
  funeralExpenses: null,
  returnOfPremium: null,
  pricingVersion: null,
  freeInstallmentsPromotion: false,
  brandingSource: null,
  insuredAmountSummary: true,
  editing: { stepperDebounceMs: 700 },
};
